import { GlobalService } from './../../../../services/global.service';
import { LicenseManager } from '../../../../managers/License.manager';
import { NoteManagerConstructor } from '../../../../managers/note.manager';
import { ssApiService } from '../../../../services/ss-api.service';
import { Note, NoteArray, NoteTypes, NoteChangeResult } from '../../../../models/domain/note';
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { NoteManager } from '../../../../managers/note.manager';

import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { WindowSettings } from '../../../../../app/services/window-dialogs/window.settings';
import { WindowTypes, WindowActionTypes } from '../../../../../app/services/window-dialogs/window.event';
import { WindowService } from '../../../../../app/services/window-dialogs/window.service';

import { SortBot } from '../../../../../app/helpers/sort';

import { regex } from '../../../../../app/shared/regex';
import { NoteDetailsDialog } from '../../../../dialogs/note.details/note.details.dialog';
import { DialogService } from '../../../../services/modal-dialogs';
import { UserRolesService } from '../../../../services/user.roles.service';
import { ConversationHistoryDialog } from 'app/dialogs/conversation.history/conversation.history.dialog';
import { ConversationThreadMessageArray } from '@models/domain/conversation.thread.message';


@Component({
    selector: 'note-list',
    templateUrl: './note.list.component.html',
    styleUrls: ['./note.list.component.scss']
})
export class NoteListComponent implements OnInit, OnDestroy {

    IsBusy: boolean = false;
    @Input('MemberID') MemberID: number;

    @Input('Title') Title: string;
    @Input('Notes') Notes: NoteArray;

    @Output('onDelete') onDelete: EventEmitter<Note> = new EventEmitter();

    @Output('onNoteChanged') onNoteChanged: EventEmitter<NoteChangeResult> = new EventEmitter();

    // Filter Variables
    memberFilterBool: boolean = true;
    licenseFilterBool: boolean = true;
    creditCardFilterBool: boolean = true;
    creditFilterBool: boolean = true;
    gisFilterBool: boolean = true;
    logFilterBool: boolean = true;
    adminLogFilterBool: boolean = true;
    memberLogFilterBool: boolean = true;
    authenticationLogFilterBool: boolean = true;
    updateLogFilterBool: boolean = true;

    NoteFilter: string;
    resultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    constructor(private api: ssApiService,
        private sweetAlertService: SweetAlertService,
        private windowService: WindowService,
        public gb: GlobalService,
        private dialogService: DialogService,
        public roles: UserRolesService) { }

    sortByDate() { this.Notes = SortBot.SortAuto(this.Notes, 'Created') }
    sortByRelation() { this.Notes = SortBot.SortAuto(this.Notes, 'RelationInfo') }
    sortByNote() { this.Notes = SortBot.SortAuto(this.Notes, 'Note') }
    sortByCreator() { this.Notes = SortBot.SortAuto(this.Notes, 'AdminName') }

    ngOnInit() {

    }

    ngOnDestroy() {

    }

    onLicenseClick(key: string): void {
        this.IsBusy = true;
        let manager = new LicenseManager()
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(key, true);
    }

    onConversationClick(conversationID: string): void {
        this.IsBusy = true;
        let title: string;
        title = "Conversation History";
    
        let options = {
            height: 800
        }

        let data: ConversationThreadMessageArray = [];

        let id = Number(conversationID.replace("CNVTHD-", ""));

        let convoDisposable = this.api.getConversationThreadMessages(id).subscribe(response => {
            data = response.Data;
            convoDisposable.unsubscribe();

            let disposable = this.dialogService.addDialog(ConversationHistoryDialog, {
                title: title,
                subTitle: "",
                message: 'Confirm message',
                conversationMessages: data
            }, options).subscribe(response => {
                disposable.unsubscribe();
                this.IsBusy = false;
            });
    
        });        

    }


    EditNote(note: Note) {
        // let noteManager = new NoteManager(new NoteManagerConstructor(note.ID));
        let noteData = new NoteManagerConstructor(note.ID);
        this.ShowNoteDialog(noteData);
    }

    ShowNoteDialog(noteData: NoteManagerConstructor) {
        let note = new NoteManager(noteData);
        let options = {
            width: 1240,
            height: 650
        }
        let disposable = this.dialogService.addDialog(NoteDetailsDialog, { noteManager: note }, options).subscribe(response => {
            disposable.unsubscribe();
        })
    }

    ShowNoteWindow(noteData: NoteManagerConstructor) {
        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        let result = this.windowService.OpenWindow<NoteManagerConstructor>(WindowTypes.Note, noteData, windowSettings);

        let subscription = result.onEvent.subscribe(event => {

            if (event.ActionType == WindowActionTypes.Saved) {
                // this.onNoteChanged( event.Data );
                this.UpdateNote(event.Data.New);
                this.onNoteChanged.emit(event.Data);
            }

            if (event.ActionType == WindowActionTypes.Close)
                subscription.unsubscribe();

        });
    }

    DeleteNote(note: Note) {
        this.IsBusy = true;

        // confirm
        this.sweetAlertService.swal(
            {
                title: 'Delete Note?',
                text: 'Are you really sure you want to do this?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.api.NoteDelete(note.ID).toPromise();
                }
            }).then(response => {

                this.IsBusy = false;

                if (!response.Result) {

                    this.sweetAlertService.swal(
                        {
                            title: 'Error',
                            text: response.Data,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                        .then(response => { })
                        .catch(error => { });

                    return;
                }

                // ok
                this.onDelete.emit(note);

                this.sweetAlertService.swal(
                    {
                        title: 'Success',
                        text: 'The note has been deleted.',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then(response => { })
                    .catch(error => { });


            }, (dismiss) => {
                this.IsBusy = false;
                return;
            }); // keep this line to prevent promise error;
    }

    sortNotesByCreateDate() {
        this.IsBusy = true;
        this.Notes = SortBot.SortAsc(this.Notes, 'Created');
        this.IsBusy = false;

    }


    TypeForNote(note: Note): string {
        let label = '';

        if (note.NoteTypeList) {
            note.NoteTypeList.forEach(function (type, i) {

                if (i > 0) {
                    label += ', ';
                }
                switch (type.Key) {
                    case NoteTypes.Member:
                        label += 'Member';
                        break;
                    case NoteTypes.GISCredit:
                        label += 'GIS Credit';
                        break;
                    case NoteTypes.CreditCard:
                        label += 'Credit Card';
                        break;
                    case NoteTypes.LicenseKey:
                        label += 'License Key';
                        break;
                    case NoteTypes.Credit:
                        label += 'Credit';
                        break;
                    case NoteTypes.Invoice:
                        label += 'Invoice';
                        break;
                    case NoteTypes.Ticket:
                        label += 'Ticket';
                        break;
                    case NoteTypes.GISUsage:
                        label += 'GIS Usage';
                        break;
                    case NoteTypes.AdminLog:
                        label += 'Admin Log';
                        break;
                    case NoteTypes.MemberLog:
                        label += 'Member Log';
                        break;
                    case NoteTypes.Hubspot:
                        label += 'Hubspot';
                        break;
                    }
            })

        }

        return label;
    }

    refreshNotes() {
        // this.onRefresh.emit("");
    }

    UpdateNote(newNote: Note): void {
        if (this.Notes === undefined || this.Notes == null) {
            this.Notes = new NoteArray();
        }

        Note.FixDates(newNote);

        let index = this.Notes.findIndex(x => x.ID == newNote.ID);
        if (index > -1) {
            this.Notes[index] = newNote;
        }

        this.sortNotesByCreateDate();
    }


    ShowMeTheNotes() {

    }

    SortMe() {
        this.sortNotesByCreateDate();
    }

    IsLicenseKey(possibleKey: string) {
        if (possibleKey) {
            return regex.IsPossibleLicenseKey(possibleKey);
        } else {
            return false;
        }
    }

    IsConversationThread(possibleThread: string){
        if (possibleThread){
            return possibleThread.startsWith("CNVTHD-");
        }
    }

    paginateNotes(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }


}
